/**
 * Short label for a language level, for the CV sidebar.
 *
 * The picker stores levels as "1".."7" and shows the long form
 * ("B2 - Gut", "C2 - Wie ein Muttersprachler"). The sidebar column is ~313px
 * wide, where the long form wraps over two lines, so the CV prints the bare
 * CEFR level instead — which is what a recruiter reads anyway.
 *
 * Unknown values render nothing rather than a placeholder, so a level added
 * to the picker without being mapped here degrades to just the language name.
 */
const SHORT_LABELS: Record<string, string> = {
  '1': 'A1',
  '2': 'A2',
  '3': 'B1',
  '4': 'B2',
  '5': 'C1',
  '6': 'C2',
  '7': 'Muttersprache',
}

export function languageLevelShortLabel(level: string | number): string {
  return SHORT_LABELS[String(level)] ?? ''
}
